import { useState } from "react";
import { useColorTheme } from "context/ColorThemeContext";
import moment from "moment";
import { Box, Typography, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import AddDesignSample from "./AddDesignSample";

function SearchDesignSampleManager({
  clickSearch,
  setSearchData,
  searchData,
  refreshDataAfterChange,
}) {
  const colors = useColorTheme();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleChange = (e) => {
    setSearchData((prev) => ({ ...prev, name: e.target.value }));
  };

  const handleCloseDialog = () => {
    setIsAddOpen(false);
    setSelectedItem(null);
  };

  return (
    <Box sx={{ mb: 3 }}>
      {/* Tiêu đề */}
      <Typography fontWeight="bold" fontSize="24px">
        QUẢN LÝ MẪU DESGIGN
      </Typography>

      {/* Ngày cập nhật */}
      <Box sx={{ mb: 1, display: "flex", alignItems: "center" }}>
        <Typography fontWeight="bold" fontSize="16px" mr={2}>
          Ngày cập nhật:
        </Typography>
        <Typography fontSize="16px">{moment().format("DD/MM/YYYY")}</Typography>
      </Box>

      {/* Nút thêm */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 6,
          mb: 2,
        }}
      >
        <Typography fontWeight="bold" fontSize="24px">
          DANH SÁCH MẪU DESIGN
        </Typography>
        <Button
          variant="contained"
          onClick={() => setIsAddOpen(true)}
          sx={{
            backgroundColor: colors.buttonBackground || "#2196F3",
            color: colors.popupText || "white",
            textTransform: "none",
          }}
          startIcon={<AddIcon />}
        >
          Thêm mới
        </Button>
      </Box>

      {/* Thanh tìm kiếm */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          placeholder="Tìm kiếm"
          size="small"
          variant="outlined"
          value={searchData.name || ""}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && clickSearch()}
          InputProps={{
            sx: {
              backgroundColor: "#f1f7ff",
              borderRadius: "8px",
              width: "250px",
              height: "45px !important",
              "& fieldset": { border: "none" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={clickSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<FilterListIcon />}
          >
            Filter
          </Button>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              textTransform: "none",
              borderColor: "#E1E3E9",
              color: "#3F4254",
            }}
            startIcon={<SortIcon />}
          >
            Sort
          </Button>
        </Box>
      </Box>

      {/* Dialog thêm mới */}
      <AddDesignSample
        open={isAddOpen}
        onClose={handleCloseDialog}
        editMode={!!selectedItem}
        initialData={selectedItem}
        refreshDataAfterChange={refreshDataAfterChange}
      />
    </Box>
  );
}

SearchDesignSampleManager.propTypes = {
  clickSearch: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
  searchData: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  refreshDataAfterChange: PropTypes.func.isRequired,
};

export default SearchDesignSampleManager;
